import { OAuthService } from 'angular-oauth2-oidc';
import { authConfig } from '../config/auth.config';
import { AuthStorageKey } from '@progressio/client-toolkit';

export function initAuth(oauthService: OAuthService) {
  return async (): Promise<void> => {
    // Set storage to localStorage
    oauthService.setStorage(localStorage);

    // Configure OAuth service
    oauthService.configure(authConfig);

    // Setup automatic silent refresh
    oauthService.setupAutomaticSilentRefresh();

    try {
      // Load discovery document and try to login
      await oauthService.loadDiscoveryDocumentAndTryLogin({
        onTokenReceived: () => {
          const stored: string | null = localStorage.getItem(AuthStorageKey.RETURN_URL);
          if (stored) {
            localStorage.removeItem(AuthStorageKey.RETURN_URL);
            window.location.replace(stored);
          }
        },
        disableOAuth2StateCheck: false,
        disableNonceCheck: false,
      });
    } catch {
      console.error('Error during authentication initialization');
    }
  };
}
